import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'

const useStyles = makeStyles(theme => ({
  root: {

  },
  button: {
    padding: 0,
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: theme.spacing(2),
  },
  form: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }
}))


const EditSlotBlocked = ({
  slot,
  onUpdate,
}) => {
  const classes = useStyles()

  const [ blocked, setBlocked ] = useState(false)
  const [ notes, setNotes ] = useState('')

  useEffect(() => {
    if(slot._blocked) {
      setBlocked(slot._blocked.value)
      setNotes(slot._blocked.notes)
    }
  }, [
    slot,
  ])

  return (
    <div className={ classes.root }>
      <div className={ classes.form }>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              control={
                <Switch checked={ blocked || false } onChange={(ev) => setBlocked(ev.target.checked)} />
              }
              label="Blocked?"
            />
          </FormGroup>
        </FormControl>
      </div>
      {
        blocked && (
          <div className={ classes.form }>
            <TextField
              fullWidth
              label="Notes"
              multiline
              rows={4}
              value={ notes }
              onChange={(ev) => setNotes(ev.target.value)}
            />
          </div>
        )
      }
      <div className={ classes.form }>
        <Button
          className={ classes.button }
          color="secondary"
          variant="outlined"
          onClick={ () => onUpdate({
            value: blocked,
            notes,
          }) }
        >
          Update
        </Button>
      </div>
    </div>
  )
}

export default EditSlotBlocked